import { useState, useEffect } from "react";
import { Button } from "../ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../ui/card";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../ui/form";
import { Checkbox } from "../ui/checkbox";

import Happy from "./Happy.png";
import Neutral from "./Neutral.png";
import Unhappy from "./Unhappy.png";

import { hooks } from "botframework-webchat-component";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

const { useSendEvent } = hooks;

const HappinessCard = ({setScript,id,surveyData,disableSend}) => {

  const sendEvent = useSendEvent();
  const [selectedFeedback, setSelectedFeedback] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [showComments, setShowComments] = useState(false);
  const [comments, setComments] = useState("");
  const [readOnly, setReadOnly] = useState(false);

  const feedbackOptions = {
    happy: [
      { id: "1", label: "Rammas Look & Feel" },
      { id: "2", label: "Ease of Getting Information through Rammas" },
      { id: "3", label: "Accuracy and Clarity of Information" },
      { id: "4", label: "Adequacy of Menus in Rammas Chatbot" },
      { id: "5", label: "Response Time of Rammas Chatbot" },
    ],
    neutral: [
      { id: "1", label: "Rammas Look & Feel" },
      { id: "2", label: "Ease of Getting Information through Rammas" },
      { id: "3", label: "Accuracy and Clarity of Information" },
      { id: "4", label: "Adequacy of Menus in Rammas Chatbot" },
      { id: "5", label: "Response Time of Rammas Chatbot" },
    ],
    unhappy: [
      { id: "1", label: "Rammas Look & Feel" },
      { id: "2", label: "Ease of Getting Information through Rammas" },
      { id: "3", label: "Accuracy and Clarity of Information" },
      { id: "4", label: "Adequacy of Menus in Rammas Chatbot" },
      { id: "5", label: "Response Time of Rammas Chatbot" },
    ],
  };

  const handleSubmit = (feedback) => {
    setSelectedFeedback(feedback);
    setExpanded(true);

    // Update the script after feedback is selected
    let visibleScript = `For the Happiness Meter, you selected ${feedback}. What made you feel this way? Please select from the following options:`;

    setScript(visibleScript); // Set the updated script
  };

  const FormSchema = z.object({
    items: z.array(z.string()).refine((value) => value.some((item) => item), {
      message: "You have to select at least one item.",
    }),
  });

  const form = useForm({
    resolver: zodResolver(FormSchema),
    defaultValues: {
      items: [],
    },
  });
  useEffect(() => {

    if (surveyData) {
      const { feedback, comments, selectedOptions } = surveyData;

      setSelectedFeedback(feedback);
      setComments(comments);
      setExpanded(true);


      form.setValue("items", selectedOptions);
      setReadOnly(true);


    }
  }, [id, form,surveyData]);

  function handleFinish() {
    const formData = form.getValues();
    const dataToSubmit = {
      feedback: selectedFeedback,
      selectedOptions: formData.items,
      comments,
    };
    const senddata = {
      id:id,
data:dataToSubmit
    }

    console.log("HappinessCard - Submitting Data: ", dataToSubmit);
    sendEvent("submitFeedback", senddata);
    setReadOnly(true);
  }

  const isMobile = window.innerWidth <= 1000; // Check if the screen size is mobile

  // Build script dynamically as text visibility changes
  useEffect(() => {
    let visibleText = `Happiness Meter: How was your experience with Rammas? Happy. Neutral . Unhappy.`;
    if (readOnly){
      visibleText = `For the happiness meter where the options are happy, neutral and, unhappy, You have selected ${selectedFeedback}.`;
      if (selectedFeedback && form.getValues("items").length > 0) {
        const selectedIds = form.getValues("items")
        const selectedLabels = selectedIds.map(id => {
          const option = feedbackOptions[selectedFeedback].find(item => item.id === id);
          return option ? option.label : null;
        }).filter(Boolean);

        visibleText += ` You selected the following options: ${selectedLabels.join(", ")}.`;
      }
      if (comments){
        visibleText += ` You have shared comments: "${comments}".... Click to hide comment`;
      }
      visibleText+= 'Thank you for your contribution'
    }else{
    if (selectedFeedback){
      visibleText = `For the happiness meter where the options are happy, neutral and, unhappy, You have selected ${selectedFeedback}.`;

    }

    // Add feedback options to the script if available
    if (selectedFeedback && form.getValues("items").length > 0) {
      const selectedIds = form.getValues("items")
      const selectedLabels = selectedIds.map(id => {
        const option = feedbackOptions[selectedFeedback].find(item => item.id === id);
        return option ? option.label : null;
      }).filter(Boolean);

      visibleText += ` You selected the following options: ${selectedLabels.join(", ")}.`;
    }
    if (selectedFeedback && form.getValues("items").length == 0){
      const options = feedbackOptions[selectedFeedback]
      console.log('Available Options',options)
      const labels = options.map(option => option.label);

      const allLabels = labels.join(", ");
      visibleText +=`What made you feel this way? please select from the following options  ${allLabels} `
    }
    if (showComments&& comments=="" ){
      visibleText += `Would you like to provide further comments? Please enter your comment".... Click to hide comment`
    }
    if (showComments && comments) {
      visibleText += ` You have shared comments: "${comments}".... Click to hide comment`;
    }
    if(selectedFeedback){
      if (!showComments){
        visibleText += `...Click to Share Comments`;

      }
      visibleText+=' ...Click to Finish'
    }
  }

    setScript(visibleText); // Update the script
    console.log("HappinessCard - Script Updated: ", visibleText); // Log the script change

  }, [selectedFeedback, showComments,form.getValues("items"), comments,readOnly]);

  // Log when the card is shown and initialized


  return (
    <Card className="border-none max-w-2xl mx-auto">
      <CardHeader>
        <CardTitle>Happiness Meter</CardTitle>
        <CardDescription>How was your experience with Rammas?</CardDescription>
      </CardHeader>
      <CardContent className="grid gap-6">
        <div className="grid grid-cols-3 gap-2 items-center">
          <div className="text-center flex flex-col items-center justify-center">
            <Button
              onClick={() => handleSubmit("happy")}
              className={`p-0 bg-transparent hover:bg-transparent border-0 ${
                isMobile ? "w-[4rem] h-[4rem]" : "w-24 h-24"
              }`}
              disabled={readOnly}
            >
              <img
                src={Happy}
                alt="Happy"
                className={`object-contain filter ${
                  isMobile ? "w-[3rem] h-[3rem]" : "w-16 h-16"
                } ${
                  selectedFeedback === "happy"
                    ? "grayscale-0 contrast-100"
                    : "grayscale contrast-0 hover:grayscale-0 hover:contrast-100"
                } transition-all duration-300`}
              />
            </Button>
            <p className="mt-2 text-sm">Happy</p>
          </div>

          <div className="text-center flex flex-col items-center justify-center">
            <Button
              onClick={() => handleSubmit("neutral")}
              className={`p-0 bg-transparent hover:bg-transparent border-0 ${
                isMobile ? "w-[4rem] h-[4rem]" : "w-24 h-24"
              }`}
              disabled={readOnly}
            >
              <img
                src={Neutral}
                alt="Neutral"
                className={`object-contain filter ${
                  isMobile ? "w-[3rem] h-[3rem]" : "w-16 h-16"
                } ${
                  selectedFeedback === "neutral"
                    ? "grayscale-0 contrast-100"
                    : "grayscale contrast-0 hover:grayscale-0 hover:contrast-100"
                } transition-all duration-300`}
              />
            </Button>
            <p className="mt-2 text-sm">Neutral</p>
          </div>

          <div className="text-center flex flex-col items-center justify-center">
            <Button
              onClick={() => handleSubmit("unhappy")}
              className={`p-0 bg-transparent hover:bg-transparent border-0 ${
                isMobile ? "w-[4rem] h-[4rem]" : "w-24 h-24"
              }`}
              disabled={readOnly}
            >
              <img
                src={Unhappy}
                alt="Unhappy"
                className={`object-contain filter ${
                  isMobile ? "w-[3rem] h-[3rem]" : "w-16 h-16"
                } ${
                  selectedFeedback === "unhappy"
                    ? "grayscale-0 contrast-100"
                    : "grayscale contrast-0 hover:grayscale-0 hover:contrast-100"
                } transition-all duration-300`}
              />
            </Button>
            <p className="mt-2 text-sm">Unhappy</p>
          </div>
        </div>

        {expanded && (
          <Form {...form}>
            <form onSubmit={form.handleSubmit(handleFinish)} className="space-y-8">
              <FormField
                control={form.control}
                name="items"
                render={() => (
                  <FormItem>
                    <div className="mb-4">
                      <FormLabel className="text-base">What made you feel this way?</FormLabel>
                    </div>
                    {feedbackOptions[selectedFeedback].map((item) => (
                      <FormField
                        key={item.id}
                        control={form.control}
                        name="items"
                        render={({ field }) => {
                          return (
                            <FormItem
                              key={item.id}
                              className="flex flex-row items-start space-x-3 space-y-0"
                            >
                              <FormControl>
                                <Checkbox
                                  checked={field.value?.includes(item.id)}
                                  onCheckedChange={(checked) => {
                                    if (!readOnly) {
                                      return checked
                                        ? field.onChange([...field.value, item.id])
                                        : field.onChange(
                                            field.value?.filter(
                                              (value) => value !== item.id
                                            )
                                          );
                                    }
                                  }}
                                  disabled={readOnly}
                                />
                              </FormControl>
                              <FormLabel className="text-sm font-normal">
                                {item.label}
                              </FormLabel>
                            </FormItem>
                          );
                        }}
                      />
                    ))}
                    <FormMessage />
                  </FormItem>
                )}
              />
              {showComments && (
                <div>
                  <label htmlFor="comments" className="text-sm font-normal">
                    Would you like to provide further comments?
                  </label>
                  <textarea
                    id="comments"
                    value={comments}
                    onChange={(e) => setComments(e.target.value)}
                    className="w-full p-2 mt-2 border rounded"
                    placeholder="Please enter your comment"
                    disabled={readOnly}
                  />
                </div>
              )}
            </form>
          </Form>
        )}
      </CardContent>
      {selectedFeedback && !readOnly && (
        <CardFooter className="flex justify-between">
          <Button
            className="w-1/2 mr-2"
            onClick={() => setShowComments(!showComments)}
          >
            {showComments ? "Hide Comments" : "Share Comments"}
          </Button>
          <Button className="w-1/2" disabled={disableSend} onClick={handleFinish}>
            Finish
          </Button>
        </CardFooter>
      )}
    </Card>
  );
};

export default HappinessCard;
